import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { OpponentVideo } from '@gem/call/CallView/Shared/OpponentVideo/OpponentVideo';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import { Opponents } from './Opponents/Opponents';
import styles from './SpeakerVideo.styles.m.css';

export const SpeakerVideo = observer(() => {
  const { call } = useCallContext();

  return (
    <div className={styles.container}>
      <div
        className={classNames(styles.speakerContainer, {
          [styles.speakerContainerWithOpponents]: call.viewState.hasPreviewOpponents,
        })}
      >
        {!!call.viewState.speakerOpponent && (
          <OpponentVideo
            key={call.viewState.speakerOpponent.uid}
            opponent={call.viewState.speakerOpponent}
            avatarType={AvatarTypes.Round_50}
            isHighlightAudio
            containerClassName={styles.speaker}
          />
        )}
      </div>
      <Opponents />
    </div>
  );
});
